// extracted by mini-css-extract-plugin
export default {"list":"service-creation-perk-list_list__VwLt1"};